import { nanoid } from 'nanoid';

export function getLongId() {
  return nanoid();
}
